import React from 'react'
import citationsCodeMap from '../../../../data/citationsCodeMap'

const CitationLink = ({ children, isLast }) => {
  const hash = citationsCodeMap[children] || ''

  return (
    <>
      <a className="italic underline" href={`/appendix#${hash}`}>
        {children}
      </a>
      {!isLast && ', '}
    </>
  )
}

export const Citations = ({ citations, className }) => {
  if (!citations) {
    return null
  }

  return (
    <div className={className}>
      {citations.gri && (
        <div>
          GRI:{' '}
          {citations.gri.map((code, index) => {
            return (
              <CitationLink
                key={code}
                isLast={index + 1 === citations.gri.length}
              >
                {code}
              </CitationLink>
            )
          })}
        </div>
      )}
      {citations.sasb && (
        <div>
          SASB:{' '}
          {citations.sasb.map((code, index) => {
            return (
              <CitationLink
                key={code}
                isLast={index + 1 === citations.sasb.length}
              >
                {code}
              </CitationLink>
            )
          })}
        </div>
      )}
      {citations.tcfd && (
        <div>
          TCFD:{' '}
          {citations.tcfd.map((code, index) => {
            return (
              <CitationLink
                key={code}
                isLast={index + 1 === citations.tcfd.length}
              >
                {code}
              </CitationLink>
            )
          })}
        </div>
      )}
    </div>
  )
}
